import type { Care } from '.';
import { CareActionType, CareItemType } from './care.ruleset';

export const careGetters = (
  Care: Care,
  { Pet, Visit }: Care['$DEPENDENCIES'],
) => (state: Care.State) => ({
  canPerformCareAction(action: CareActionType | CareItemType, now: number) {
    const isVisiting = Visit.getters(state).isVisiting();
    const petState = Pet.getters(state).getPetState(now, isVisiting);

    // Sleeping and want to go out disable care menu
    if (petState === 'sleeping' || petState === 'want_to_go_out') {
      return false;
    }

    // If player is dead disable care menu
    if (petState === 'dead') return false;

    // If player is dying allow only first aid
    if (petState === 'dying') {
      return action === 'first_aid';
    }

    switch (action) {
      case 'food':
      case 'snack': {
        return petState !== 'tooth_decay';
      }

      case 'bath':
      case 'toilet':
        return petState !== 'scared';

      default: {
        return true;
      }
    }
  },

  getCareActionCount: () => state.care.careActionCount,
});
